import { useState } from "react";

export const useLocalStorage = <T>(key: string, initialValue: T): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      // Handle cases where item might be "undefined" string or null
      if (!item || item === "undefined" || item === "null") {
        return initialValue;
      }
      return JSON.parse(item);
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      // Clear invalid data from localStorage
      try {
        window.localStorage.removeItem(key);
      } catch (e) {
        // Ignore errors when clearing
      }
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    try {
      setStoredValue(value);
      // Only store if value is not undefined
      if (value !== undefined && value !== null) {
        window.localStorage.setItem(key, JSON.stringify(value));
      } else {
        // Remove the key if value is undefined or null
        window.localStorage.removeItem(key);
      }
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  };

  return [storedValue, setValue];
};

export const clearLocalStorage = (key: string): void => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error clearing localStorage key "${key}":`, error);
  }
};

